import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertasComponent } from '../alertas/alertas.component';
import { SmsCodeComponent } from './components/sms-code/sms-code.component';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-modifyaccounts',
  templateUrl: './modifyaccounts.component.html',
  styleUrls: ['./modifyaccounts.component.sass']
})
export class ModifyaccountsComponent implements OnInit {
  public tabActive = 'Manejo de Cuenta';
  public banlist: object;
  public selectBan: string;
  public currentList;
  public myInterval = 30000;
  public postpago = false;
  public prepago = false;
  public telefoniaFijo = false;
  public totalAccountList;
  public token: string = sessionStorage.getItem("token");
  public data: object;
  public offers: Array<any>;
  public addUsersView = false;
  public accountList;
  public accountId: string = '';
  public ssn: string = '';
  public markMainAccount: boolean = false;
  public statusLoader: boolean = false;
  public defaultSubcriber;
  public expand = [];
  public messageSMS = false;
  public smsCode = false;
  public prepaidtoken = '';
  public suscriptorId;
  public pin;
  public id;
  public addPrepaid = false;
  constructor(private services: Service, private route: ActivatedRoute, private router: Router, private loadingScreenService: LoadingScreenService, public global: GlobalService, public dialog: MatDialog, public AngularFireAnalytics: AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Mis Cuentas");
    this.AngularFireAnalytics.logEvent("Mis Cuentas-Screenview");
  }
  ngOnInit() { 
  }
  ngAfterContentInit() {
    if (sessionStorage.getItem("banlist") != undefined && this.accountList == null) {
      this.accountList = JSON.parse(atob(sessionStorage.getItem("banlist")));
    }
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.selectBan = '';
    this.accountDetails(false);
    this.getId();
  }
  getId() {
    if (this.route.firstChild) {
      this.id = this.route.firstChild.snapshot.params.id;
      if (this.id) {
        this.unCollapse();
      }
      else {
        this.router.navigate(['modifyaccounts']);
      }
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  updateExpand(index) {
    this.global.validateSession();
    this.expand[index] = !this.expand[index];
  }
  accountDetails(sw) {
    this.offers = [];
    if (this.accountList == undefined || this.accountList == null || sw == true) {
      this.statusLoader = true;
      this.services.getAcounts(sessionStorage.getItem("token")).subscribe(result => {
        this.loadingScreenService.stopLoading();
        if (result.hasError == false) {
          sessionStorage.setItem("banlist", btoa(JSON.stringify(result)));
          this.accountList = result.accounts;
          for (let i = 0; this.accountList.length > i; i++) {
            for (let k = 0; this.accountList[i].subscribers.length > k; k++) {
              if (this.accountList[i].defaultAccount == true) {
                if (this.accountList[i].subscribers[k].defaultSubcriber == true) {
                  this.defaultSubcriber = this.accountList[i].subscribers[k].subscriber;
                }
              }
            }
          }
          this.accountDetailsLoad(0);
        }
        else {
          this.global.notif(result.ErrorDesc);
        }
      });
    }
    else {
      this.statusLoader = false;
      this.accountList = this.accountList.accounts;
      for (let i = 0; this.accountList.length > i; i++) {
        for (let k = 0; this.accountList[i].subscribers.length > k; k++) {
          if (this.accountList[i].defaultAccount == true) {
            if (this.accountList[i].subscribers[k].defaultSubcriber == true) {
              this.defaultSubcriber = this.accountList[i].subscribers[k].subscriber;
            }
          }
        }
      }
      this.accountDetailsLoad(0);
    }
  }
  accountDetailsLoad(index) {
    if ((parseInt(this.accountList.length) - 1) == index) {
      this.offers.push(JSON.parse(this.offersData(this.accountList[index].subscribers, this.accountList[index].account, this.accountList[index].defaultAccount, this.accountList[index].accountType, this.accountList[index].accountSubType, this.accountList[index].accountName, this.accountList[index].registerDate)));
      this.loadOffers(this.offers);
    }
    else {
      this.offers.push(JSON.parse(this.offersData(this.accountList[index].subscribers, this.accountList[index].account, this.accountList[index].defaultAccount, this.accountList[index].accountType, this.accountList[index].accountSubType, this.accountList[index].accountName, this.accountList[index].registerDate)));
      this.accountDetailsLoad((index + 1));
    }
  }
  addAccount() {
    if (this.global.validateSession() === true) {
      this.suscriptorId = this.accountId;
      this.pin = this.ssn;
      if (this.accountId.length > 9) {
        this.addPrepaid = true;
        //Prepago
        if (this.suscriptorId == "") {
          this.global.notif("Debe ingresar el número de teléfono.");
        }
        else {
          if (this.pin == "") {
            this.global.notif("Debe ingresar el pin.");
          }
          else {
            this.services.validatePrepaid(this.suscriptorId, this.pin).subscribe(data => {
              if (data.success == true || true) { // revisar este cable
                this.prepaidtoken = '';
                this.loadingScreenService.stopLoading();
                this.resendCode(this.prepaidtoken);//va el token validatePrepaid
              }
              else {
                this.loadingScreenService.stopLoading();
                this.global.notif(data.error);
              }
            });
          }
        }
      }
      else {
        this.addPrepaid = false;
        if (this.global.validateSession() === true) {
          if (this.accountId == "") {
            this.global.notif("Debe ingresar el número de cuenta.");
          }
          else {
            if (this.ssn == "") {
              this.global.notif("Debe ingresar los últimos 4 digitos del seguro social.");
            }
            else {
              var sw = 0;
              if (this.accountId.length != 9) {
                sw = 1;
                this.global.notif("Debe ingresar al menos 9 numeros.");
              }
              else {
                if (this.ssn.length != 4) {
                  sw = 1;
                  this.global.notif("Debe ingresar al menos 4 numeros.");
                }
              }
              if (sw == 0) {
                this.loadingScreenService.startLoading();
                this.services.addAccount(this.accountId, this.ssn, this.markMainAccount, sessionStorage.getItem("token")).subscribe(result => {
                  if (result.hasError == false) {
                    this.services.accountRefresh(sessionStorage.getItem("token")).subscribe(data => {
                      if (data.hasError == false) {
                        //if (this.markMainAccount == true) {}
                        this.offers = [];
                        this.accountDetails(true);
                        this.accountId = "";
                        this.ssn = "";
                        this.global.notif("Se ha agregado la cuenta con exito.");
                      }
                      else {
                        this.loadingScreenService.stopLoading();
                        this.global.notif(result.errorDisplay);
                      }
                    });
                  }
                  else {
                    this.loadingScreenService.stopLoading();
                    this.global.notif(result.errorDisplay);
                  }
                });
              }
            }
          }
        }
      }
    }
  }
  offersData(subscriptores, ban, defaultAccount, accountType, accountSubType, userName, registerDate) {
    let typeAccount = this.global.checkTypeAccount(accountType, accountSubType);
    if (defaultAccount == false) {
      defaultAccount = 'N';
    }
    else {
      defaultAccount = 'Y';
    }
    let ofertas = '{"ban":"' + ban + '","defaultAccount":"' + defaultAccount + '","productType":"' + typeAccount + '","accountType":"' + accountType + '","accountSubType":"' + accountSubType + '","userName":"' + userName + '","registerDate":"' + registerDate + '","offers":[';
    for (var i = 0; i < subscriptores.length; i++) {
      if (i > 0) {
        ofertas += ',';
      }
      ofertas += '"' + subscriptores[i].subscriber + '"';
    }
    ofertas += ']}';
    return ofertas;
  }
  loadOffers(offers) {
    let ofertas = '{"offers":[';
    for (var i = 0; i < offers.length; i++) {
      if (i > 0) {
        ofertas += ',';
      }
      ofertas += '{"offers":[' + JSON.stringify(offers[i]) + ']}';
    }
    ofertas += ']}';
    this.offers = JSON.parse(ofertas);
    this.updateExpand(0);
  }
  unCollapse() {
    if (this.global.validateSession() === true) {
      this.addUsersView = true;
    }
  }
  collapse() {
    if (this.global.validateSession() === true) {
      this.addUsersView = false;
    }
  }
  updNum() {
    if (this.accountId.length > 9) {
      this.addPrepaid = true;
    }
    else {
      this.addPrepaid = false;
    }
  }
  closeMessage() {
    this.messageSMS = false;
    this.smsCode = true;
  }
  notifSms() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: 'SMS con códigos de verificación ha sido enviado.', btmOk: true };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {
        this.notifSmsCode();
      }
    });
  }
  notifSmsCode() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { accountId: this.accountId };
    const dialogRef = this.dialog.open(SmsCodeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {

      }
    });
  }
  resendCode(token) {
    this.notifSms();
    this.prepaidtoken = this.token;
    this.messageSMS = true;
    //this.loadingScreenService.startLoading();
    this.global.notif("resendCode");
    // this.services.resendCode(this.token).subscribe(data => {
    //   if(data.success==true){
    //       this.loadingScreenService.stopLoading();
    //     }
    //     else{
    //         this.loadingScreenService.stopLoading();
    //         this.global.notif(data.error);
    //     }
    // });
  }
  deleteAccount(account, index) {
    if (this.global.validateSession() === true) {
      this.loadingScreenService.startLoading();
      this.services.deleteAccount(sessionStorage.getItem("token"), account).subscribe(result => {
        this.loadingScreenService.stopLoading();
        if (result.hasError == false) {
          this.global.notif("Se ha eliminado con exito.");
          this.accountDetails(true);
        }
        else {
          this.global.notif(result.errorDisplay);
        }
      });
    }
  }
  mainAccountChange(sw, account, productType, accountType, accountSubType, i) {
    let defaultSubcriber = '';
    let sw2: boolean = false;
    let sw3: boolean = false;
    for (let k = 0; this.accountList[i].subscribers.length > k; k++) {
      if (this.accountList[i].subscribers[k].subscriber == this.defaultSubcriber) {
        sw2 = true;
      }
    }
    if (sw == true) {
      if (sw2 == true) {
        defaultSubcriber = this.defaultSubcriber;
      }
      else {
        defaultSubcriber = this.accountList[i].subscribers[0].subscriber;
      }
      sw3 = true;
    }
    else {
      if (sw2 == true) {
        defaultSubcriber = this.defaultSubcriber;
        sw3 = true;
      }
      else {
        sw3 = false;
        this.global.notif("Debe selecionar un suscriptor en esta cuenta para realizar el cambio.");
      }
    }
    if (sw3 == true) {
      this.loadingScreenService.startLoading();
      this.services.setAsDefaultAccount(account, defaultSubcriber, accountType, accountSubType, productType, sessionStorage.getItem("token")).subscribe(result => {
        this.loadingScreenService.stopLoading();
        if (result.hasError == false) {
          sessionStorage.setItem("mainAccount", account); //revisar estas variables
          sessionStorage.setItem("defaultSubscriber", this.defaultSubcriber); //revisar estas variables
          this.global.notif("Se ha cambiado con exito.");
          this.accountDetails(true);
        }
        else {
          this.global.notif(result.errorDesc);
        }
      });
    }
  }
}